"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valle-di-casies": {
    "fd71911d": [{
      "hkey": "28a0cde4",
      "slug": "colle",
      "name": "Colle",
      "primary": true,
      "skipSearch": false
    }],
    "colle-di-dentro": [{
      "hkey": "28a0cde4",
      "slug": "colle",
      "name": "Colle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "144c1f36": [{
      "hkey": "28a0cde4",
      "slug": "colle",
      "name": "Colle",
      "primary": true,
      "skipSearch": false
    }],
    "colle-di-fuori": [{
      "hkey": "28a0cde4",
      "slug": "colle",
      "name": "Colle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valle-di-casies"
    }],
    "97a910da": [{
      "hkey": "a87ebfc0",
      "slug": "san-martino",
      "name": "San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino-valbassa": [{
      "hkey": "a87ebfc0",
      "slug": "san-martino",
      "name": "San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valle-di-casies"
    }],
    "e11b12df": [{
      "hkey": "a87ebfc0",
      "slug": "san-martino",
      "name": "San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino-valltalta": [{
      "hkey": "a87ebfc0",
      "slug": "san-martino",
      "name": "San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valle-di-casies"
    }],
    "8c67cf66": [{
      "hkey": "3195adb8",
      "slug": "santa-maddalena",
      "name": "Santa Maddalena",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maddalena-valbassa": [{
      "hkey": "3195adb8",
      "slug": "santa-maddalena",
      "name": "Santa Maddalena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valle-di-casies"
    }],
    "9e3a4f2a": [{
      "hkey": "3195adb8",
      "slug": "santa-maddalena",
      "name": "Santa Maddalena",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maddalena-valltalta": [{
      "hkey": "3195adb8",
      "slug": "santa-maddalena",
      "name": "Santa Maddalena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valle-di-casies"
    }]
  }
};
exports["default"] = _default;